var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkTooltipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_9875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88867 11.1109H8.44423V7.13845C8.44423 7.13356 8.44289 7.12912 8.44289 7.12467C8.44289 7.12023 8.44423 7.11578 8.44423 7.11089C8.44423 6.86556 8.24512 6.66645 7.99978 6.66645H7.11089C6.86556 6.66645 6.66645 6.86556 6.66645 7.11089C6.66645 7.35623 6.86556 7.55534 7.11089 7.55534H7.55534V11.1109H7.11089C6.86556 11.1109 6.66645 11.31 6.66645 11.5553C6.66645 11.8007 6.86556 11.9998 7.11089 11.9998H8.88867C9.13401 11.9998 9.33312 11.8007 9.33312 11.5553C9.33312 11.31 9.13401 11.1109 8.88867 11.1109ZM7.99978 5.77756C8.49089 5.77756 8.88867 5.37934 8.88867 4.88867C8.88867 4.39801 8.49089 3.99978 7.99978 3.99978C7.50867 3.99978 7.11089 4.39801 7.11089 4.88867C7.11089 5.37934 7.50912 5.77756 7.99978 5.77756ZM7.99978 0.888672C4.07267 0.888672 0.888672 4.07223 0.888672 7.99978C0.888672 11.9273 4.07223 15.1109 7.99978 15.1109C11.9273 15.1109 15.1109 11.9273 15.1109 7.99978C15.1109 4.07223 11.9273 0.888672 7.99978 0.888672ZM7.99978 14.2358C4.56867 14.2358 1.77756 11.4304 1.77756 7.99934C1.77756 4.56823 4.56867 1.77712 7.99978 1.77712C11.4309 1.77712 14.222 4.56823 14.222 7.99934C14.222 11.4304 11.4309 14.2358 7.99978 14.2358Z",
    fill: "#FF627D",
    stroke: "#FF627D",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_9875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkTooltipIcon);
export default __webpack_public_path__ + "static/media/pink-tooltip-icon.6c00b7e907632a88bc12669e72fd6bf0.svg";
export { ForwardRef as ReactComponent };